import {
  MapPin, Clock, CreditCard, GraduationCap, Trophy, Target,
  Palette, Code2, Server, Database, BarChart2, Boxes,
  CalendarCheck, Brain, CheckCircle2, Send, Gift
} from "lucide-react";

const ICONS = {
  MapPin, Clock, CreditCard, GraduationCap, Trophy, Target,
  Palette, Code2, Server, Database, BarChart2, Boxes,
  CalendarCheck, Brain, CheckCircle2, Send, Gift
};

export default function Icon({ name, size = 18, color, className = "" }) {
  const Comp = ICONS[name];
  if (!Comp) return null;
  return <Comp size={size} color={color} className={className} strokeWidth={2} />;
}